export default "__VITE_ASSET__VSXeSL90__"